import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IContextService, DomainContext } from '@pershing/pershing-core';
import { NxiRestService } from './NXI-Rest.service';
import { NxiContextUtils } from '@pershing/nxi-common';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BlanceKeyRestService {
    balanceUrl = '/balances';
    subs: any;
    domain: any;
    acctRef: any;
    qaInternalUrl: any;
    balancesResponse$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    constructor(private httpClient: HttpClient, private contextService: IContextService, private nxiRestService: NxiRestService) {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.acctRef = contextValue.hashValue;
        });
        this.qaInternalUrl = this.nxiRestService.serviceUrl;
        // this.qaInternalUrl  =  'https://qa-netxinvestor-internal.test.bnymellon.net/test-netxinvestor-rest-service-qa-app/netxclient.rest-service';
    }
    getBalancesKeyValues(realtime: boolean): any {
        const options = {
            headers: new HttpHeaders().append('Account', this.acctRef)
        };
        return this.httpClient.get(this.qaInternalUrl + '/portfolio/' + 'urn:id:headers.Account' + this.balanceUrl + '?&rt=' + realtime, options );
    }
    getLiabilities(): Observable<any> {
        let timeNow = Date.now();
        return this.httpClient.get<any>(this.qaInternalUrl + '/portfolio/' + '/mortgageLoans' + '?time=' + timeNow);
    }
}
